import React from "react";
import AutoTyping from "react-auto-typing";
import operationImage from "../../../assets/operation-management.jpg";
import technicianImage from "../../../assets/technician-empowerment.jpg";
import customerImage from "../../../assets/customer-engagement.png";
import contractImage from "../../../assets/contract-management.png";

const FeaturesOnServices = () => {
  return (
    <div className="active-feature-section-wrapper">
      <div className="section-title">
        <h1 className="title">Key Features of Active</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={operationImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Operations & Employee Management</h1>
            <ul className="main-list">
              <li>
                <h6>Centralized Payroll Control</h6>
                <ul className="inner-list">
                  <li>
                    Manage all payroll activities from a single platform,
                    streamlining payroll processing, tax compliance, and
                    employee benefits. Track and resolve payroll issues in
                    real-time, ensuring accuracy and compliance.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Automated Scheduling & Timesheets</h6>
                <ul className="inner-list">
                  <li>
                    Automatically sync employee schedules, attendance, and
                    overtime to generate payroll with precision. Eliminate
                    errors and delays by connecting time-tracking directly to
                    payroll processing.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Advanced Reporting</h6>
                <ul className="inner-list">
                  <li>
                    Create detailed payroll reports to monitor employee costs,
                    labor expenses, and more. Customize insights to make
                    strategic decisions that optimize HR budgets.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Employee Empowerment</h1>
            <ul className="main-list">
              <li>
                <h6>Self-Service Portals</h6>
                <ul className="inner-list">
                  <li>
                    Let employees access their payroll information, request time
                    off, and view benefits—all from one convenient portal.
                    Empower your workforce while reducing HR overhead.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Mobile Payroll Access</h6>
                <ul className="inner-list">
                  <li>
                    Employees can view payslips, update personal information,
                    and receive notifications on the go with mobile-friendly
                    access. Foster transparency and ensure employees stay
                    informed anytime, anywhere.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Digital Payslip Distribution</h6>
                <ul className="inner-list">
                  <li>
                    Deliver payslips digitally, cutting down on paperwork and
                    ensuring timely access to important payroll details.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={technicianImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={customerImage} alt="image" />
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Compliance & Risk Management</h1>
            <ul className="main-list">
              <li>
                <h6>Automated Tax Filing</h6>
                <ul className="inner-list">
                  <li>
                    Stay compliant with federal and local tax regulations
                    through automated filings and deductions. Active keeps you
                    up to date with changing laws and ensures accurate tax
                    submissions.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Employee Benefits Management</h6>
                <ul className="inner-list">
                  <li>
                    Easily manage and track employee benefits, from healthcare
                    to retirement plans, all within one integrated system.
                    Automate contributions and reporting for seamless
                    compliance.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>Employee Lifecycle Management</h1>
            <ul className="main-list">
              <li>
                <h6>Onboarding & Offboarding</h6>
                <ul className="inner-list">
                  <li>
                    Streamline employee onboarding with digital forms, automated
                    task assignments, and easy access to company policies.
                    Manage offboarding efficiently with automated paperwork and
                    exit formalities.
                  </li>
                </ul>
              </li>
              <li>
                <h6>Contract & Payroll Management</h6>
                <ul className="inner-list">
                  <li>
                    Automate contract renewals, manage payroll cycles, and
                    maintain compliance effortlessly. Ensure timely payments and
                    easily track work hours, bonuses, and incentives.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={contractImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesOnServices;
